import { Box } from "@mui/material"
import { isCapacitorNative } from "Utils/Constants"

const TouchBox = ({ sx = {}, onClick, children, ...rest }: any) => {
  const isCapacitor = isCapacitorNative();

  return (
    <Box
      sx={{
        ...sx,
        ...(isCapacitor
          ? {
              touchAction: 'manipulation',
              WebkitTapHighlightColor: 'transparent',
              cursor: 'pointer',
            }
          : { cursor: 'pointer' }),
      }}
      onTouchStart={isCapacitor ? onClick : undefined}
      onClick={!isCapacitor ? onClick : undefined}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default TouchBox;
